export default () => ({
  root: {
    height: '100%',
    overflow: 'hidden',
    position: 'absolute',
  },
});
